export function resetSilenceTimerOnRecordingChange({
  isSubmitting,
  isRecording,
  silenceStartTimeRef,
}: {
  isSubmitting: boolean;
  isRecording: boolean;
  silenceStartTimeRef: React.RefObject<number | null>;
}): void {
  if (isSubmitting) {
    silenceStartTimeRef.current = null;
  } else if (isRecording) {
    silenceStartTimeRef.current = Date.now();
  }
}
